<template>
    <v-dialog v-model="dialog" width="500" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-col cols="12">
                        <v-select
                        v-model="pageOrientation"
                        variant="outlined"
                        :rules="[formRules.required]"
                        label="Page Orientation"
                        color="darkGreen"
                        :items="pageOrientationData"
                        item-title="name"
                        item-value="value"
                        ></v-select>
                    </v-col>
                    <v-col cols="12">
                        <v-select
                        v-model="pageSize"
                        variant="outlined"
                        :rules="[formRules.required]"
                        label="Page Size"
                        color="darkGreen"
                        :items="pageSizeData"
                        item-title="name"
                        item-value="value"
                        return-object
                        ></v-select>
                    </v-col>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Print" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    emits: ["print"],
    data () {
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            pageSize: null,
            pageOrientation: null,

            pageSizeData: [
                {
                    name: 'Long',
                    size: { width: 612, height: 936 },
                    margins: [35, 130, 35, 80]
                },
                {
                    name: 'Letter',
                    size: { width: 612, height: 792 },
                    margins: [35, 130, 35, 80]
                },
                {
                    name: 'A4',
                    size: { width: 595.28, height: 841.89 },
                    margins: [35, 130, 35, 80]
                }
            ],

            pageOrientationData: [
                { name: 'Landscape', value: 'landscape'},
                { name: 'Portrait', value: 'portrait'}
            ]
        }
    },
    methods: {
        init(){
            this.dialog = true
            this.dialog_title = 'Print Page Details'
            this.dialog_sub_title = 'Select page orientation and size'
            this.action = 'print'

            this.pageOrientation = 'landscape'
            this.pageSize = {
                                name: 'Long',
                                size: { width: 612, height: 936 },
                                margins: [35, 130, 35, 80]
                            }
        },
        async validateForm(){
            const { valid } = await this.$refs.form.validate()

            if(valid){
                    this.$emit("print", {
                    pageSize: this.pageSize.size,
                    pageMargins: this.pageSize.margins,
                    pageOrientation: this.pageOrientation
                });

                this.dialog = false;
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
    }
})
</script>

<style scoped>

</style>